import { AccessTokenManager } from '@spotify-internal/access-token';
import { getSpotifyClientId } from '@mrkt/features/env';

const clientId = getSpotifyClientId();
const isInternal = window.location.hostname.endsWith('.spotify.net');

const webgateDomain = isInternal
  ? 'https://wgint.spotify.net'
  : 'https://generic.wg.spotify.com';

export function getAccountsDomain() {
  return isInternal
    ? 'https://accounts.spotify.net'
    : 'https://accounts.spotify.com';
}

export const accessTokenManager = new AccessTokenManager({
  url: `${webgateDomain}/creator-auth-proxy/v1/web/token?client_id=${clientId}`,
  options: { credentials: 'include' },
});
